import { render, staticRenderFns } from "./classifyModal.vue?vue&type=template&id=6cf29714&scoped=true&"
import script from "./classifyModal.vue?vue&type=script&lang=js&"
export * from "./classifyModal.vue?vue&type=script&lang=js&"
import style0 from "./classifyModal.vue?vue&type=style&index=0&id=6cf29714&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf29714",
  null
  
)

export default component.exports